import React from "react";
import LegalLayout from "@/components/site/LegalLayout";

export default function Impressum() {
  return (
    <LegalLayout overline="Rechtliches" title="Impressum">
      <section data-testid="impressum-section-anbieter">
        <h2 className="font-serif-elegant text-2xl text-ocean mb-3">
          Angaben gemäß § 5 DDG
        </h2>
        <p>
          Kerstin Cloodt<br />
          Freie Künstlerin, Begleiterin beim Malen<br />
          Landaustraße 5<br />
          34121 Kassel<br />
          Deutschland
        </p>
      </section>

      <section data-testid="impressum-section-kontakt">
        <h2 className="font-serif-elegant text-2xl text-ocean mb-3">Kontakt</h2>
        <p>
          Telefon:{" "}
          <a
            href="tel:+4915168129874"
            className="text-ocean hover:text-terracotta transition-colors"
          >
            0151&nbsp;68129874
          </a>
          <br />
          E-Mail:{" "}
          <a
            href="mailto:kerstin.cloodt@googlemail.com"
            className="text-ocean hover:text-terracotta transition-colors"
          >
            kerstin.cloodt@googlemail.com
          </a>
        </p>
      </section>

      <section data-testid="impressum-section-verantwortlich">
        <h2 className="font-serif-elegant text-2xl text-ocean mb-3">
          Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV
        </h2>
        <p>
          Kerstin Cloodt<br />
          Landaustraße 5<br />
          34121 Kassel
        </p>
      </section>

      <section data-testid="impressum-section-eu">
        <h2 className="font-serif-elegant text-2xl text-ocean mb-3">
          EU-Streitschlichtung
        </h2>
        <p>
          Die Europäische Kommission stellt eine Plattform zur
          Online-Streitbeilegung (OS) bereit:{" "}
          <a
            href="https://ec.europa.eu/consumers/odr/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-ocean hover:text-terracotta transition-colors"
          >
            https://ec.europa.eu/consumers/odr/
          </a>
          . Meine E-Mail-Adresse finden Sie oben im Impressum.
        </p>
      </section>

      <section data-testid="impressum-section-verbraucher">
        <h2 className="font-serif-elegant text-2xl text-ocean mb-3">
          Verbraucherstreitbeilegung / Universalschlichtungsstelle
        </h2>
        <p>
          Ich bin nicht bereit oder verpflichtet, an Streitbeilegungsverfahren
          vor einer Verbraucherschlichtungsstelle teilzunehmen.
        </p>
      </section>

      <section data-testid="impressum-section-haftung-inhalte">
        <h2 className="font-serif-elegant text-2xl text-ocean mb-3">
          Haftung für Inhalte
        </h2>
        <p>
          Als Diensteanbieterin bin ich gemäß § 7 Abs. 1 DDG für eigene Inhalte
          auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach
          §§ 8 bis 10 DDG bin ich als Diensteanbieterin jedoch nicht
          verpflichtet, übermittelte oder gespeicherte fremde Informationen zu
          überwachen oder nach Umständen zu forschen, die auf eine
          rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung
          oder Sperrung der Nutzung von Informationen nach den allgemeinen
          Gesetzen bleiben hiervon unberührt.
        </p>
      </section>

      <section data-testid="impressum-section-haftung-links">
        <h2 className="font-serif-elegant text-2xl text-ocean mb-3">
          Haftung für Links
        </h2>
        <p>
          Mein Angebot enthält gegebenenfalls Links zu externen Websites
          Dritter, auf deren Inhalte ich keinen Einfluss habe. Deshalb kann ich
          für diese fremden Inhalte auch keine Gewähr übernehmen. Für die
          Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder
          Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden
          zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft.
          Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht
          erkennbar.
        </p>
      </section>

      <section data-testid="impressum-section-urheberrecht">
        <h2 className="font-serif-elegant text-2xl text-ocean mb-3">
          Urheberrecht
        </h2>
        <p>
          Die durch die Seitenbetreiberin erstellten Inhalte und Werke auf
          diesen Seiten, insbesondere alle Abbildungen der gezeigten
          Kunstwerke, unterliegen dem deutschen Urheberrecht. Die
          Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
          Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der
          schriftlichen Zustimmung von Kerstin Cloodt. Downloads und Kopien
          dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch
          gestattet.
        </p>
      </section>
    </LegalLayout>
  );
}
